module.exports = __webpack_public_path__ + "media/logos/glg-logo-black-4536bb19.png";